export enum EventActionType {
  /*
   | ---------------------------------------------------------------------------
   | Event Creation Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for creating a new events.
   |
   */
  CreateEventError = 'event/CREATE_ERROR',
  CreateEventRequest = 'event/CREATE_REQUEST',
  CreateEventSuccess = 'event/CREATE_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   | Event Deletion Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for creating a new events.
   |
   */
  DeleteEventError = 'event/DELETE_ERROR',
  DeleteEventRequest = 'event/DELETE_REQUEST',
  DeleteEventSuccess = 'event/DELETE_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   | Event Load Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for loading and unloading existing events into/out of
   | the store from the server.
   |
   */
  LoadEvent = 'event/LOAD',
  LoadEventError = 'event/LOAD_ERROR',
  LoadEventRequest = 'event/LOAD_REQUEST',
  LoadEventSuccess = 'event/LOAD_SUCCESS',
  UnloadEvent = 'event/UNLOAD',

  /*
   | ---------------------------------------------------------------------------
   | Event Setter Actions
   | ---------------------------------------------------------------------------
   |
   | These actions set the value of some field of an individual event currently
   | in the store.
   |
   */
  SetEventCategoryIds = 'event/SET_CATEGORY_IDS',
  SetEventDescription = 'event/SET_DESCRIPTION',
  SetEventError = 'event/SET_ERROR',
  SetEventLocationId = 'event/SET_LOCATION_ID',
  SetEventName = 'event/SET_NAME',
  SetEventPageId = 'event/SET_PAGE_ID',
  SetEventPageTitle = 'event/SET_PAGE_TITLE',
  SetEventPlaceId = 'event/SET_PLACE_ID',
  SetEventPlaceName = 'event/SET_PLACE_NAME',
  SetEventPosterImages = 'event/SET_POSTER_IMAGES',
  SetEventRecurrenceRules = 'event/SET_RECURRENCE_RULES',
  SetEventStatus = 'event/SET_STATUS',
  SetEventTagIds = 'event/SET_TAG_IDS',
  SetEventTags = 'event/SET_TAGS', // TODO: this eventually will go away w/ new tag editor.

  AddOccurrence = 'event/ADD_OCCURRENCE',
  AddManyOccurrences = 'events/ADD_MANY_OCCURRENCES',
  RemoveOccurrence = 'event/REMOVE_OCCURRENCE',
  RemoveAllOccurrences = 'event/REMOVE_ALL_OCCURRENCES',

  SetOccurrenceStartsAt = 'event/SET_OCCURRENCE_STARTS_AT',
  SetOccurrenceDuration = 'event/SET_OCCURRENCE_DURATION',

  /*
   | ---------------------------------------------------------------------------
   | Event Update Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for updating existing events.
   |
   */
  UpdateEventError = 'event/UPDATE_ERROR',
  UpdateEventRequest = 'event/UPDATE_REQUEST',
  UpdateEventSuccess = 'event/UPDATE_SUCCESS',
}
